import { ViewChild, Inject } from '@angular/core';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenService } from '../services/authen.service';
import { HttpService } from '../services/http.service';
import { HelperService } from '../services/helper.service';
import { NotifyService } from '../services/notify.service';
import { UrlParams } from '../helpers/url-params';
import * as AppConst from '../data/test.data';
import { SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { Util } from '../helpers/global.util';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';


export class RequestBase {    
    @ViewChild('grid') grid;
    requestStatusDefault: string = "0";
    subs: any = null;
    items: any = null;
    data: DataManager;    
    //toolbar: object;

    loading: boolean = false;
    pathCode: number = 0;
    pageSettings: PageSettingsModel;
    subsNotify: Subscription;    
    requestStatusList: any[] = [];
    requestTypeMList: any[] = [];
    areaMList: string[] = [];
    enableRequestTypeList: boolean = true;
    enableAreaList: boolean = true;
    requestStatusSelected: string = null;
    fromDate: Date = null;
    toDate: Date = null;

    keywordCustomerSearch: string = null;
    keywordSCSearch: string = null;
    requestCodeSearch: string = null;
    requestTypesSelected: string[] = [];
    areaSelected: string[] = [];
    provinceSearch: string = "";


    internalCodeList: any[] = [];
    internalCodeSelected: string = null;
    checkRequestTypeMList: boolean = false;
    checkAreaMList: boolean = false;    

    isProcessingChangeStatus: boolean = false;

    requestSelecteds: Array<any> = [];

    provinceDDL: Array<any> = [];

    /*----------end export report --------*/
    @ViewChild('dialogConfirmDoneRequest') dialogConfirmDoneRequest: DialogComponent;
    dialogHeaderImport: string = "Xác nhận  chuyển Done";

    @ViewChild('dialogConfirmInprogressRequest') dialogConfirmInprogressRequest: DialogComponent;



    dialogWidth: string = "50%";
    dialogHeight: string = "250px;";
    diaLogPosition: object = { X: 'center', Y: 'top' };

    objSearch: any = {};

    get AppConst() { return AppConst; }

    isFinishStatusDDL: boolean = false;
    isFinishProvinceDDL: boolean = false;
    lstParamSearch: Array<any> = [];
    routeHere: string = "";

    constructor(public auth: AuthenService, protected http: HttpService, private httpClient: HttpClient, protected helper: HelperService, protected notify: NotifyService
        , protected translate: TranslateService, public router: Router, private route: ActivatedRoute, @Inject('BASE_URL') public baseUrl: string) {
        this.pageSettings = { pageSize: 10 };        



        this.subs = route.params.subscribe(params => {
 
           // this.requestStatusDefault = params['status'] != null ? params['status'] : "0";

           // this.filterSearch = this.requestStatusDefault;
            
            this.checkAllDDLFinsih();

        })
        

    }

    init() {
       

        this.subsNotify = this.notify.getMessage().subscribe(msg => {
            this.grid.refreshHeader();
           
        });        
       
        this.http.get('api/Util/GetRequestStatusList', res => {
            this.requestStatusList = res.Result;
            this.isFinishStatusDDL = true;
            this.checkAllDDLFinsih();
        }, null);
        if (this.auth.GroupUserCode == 'SC') {
            this.http.get(`api/Util/GetInternalCodeList/${this.auth.LoginUser}`, res => {
                this.internalCodeList = res.Result;
                this.internalCodeSelected = this.auth.UserNameInternal;
            }, null);
        }
        this.findRequestTypes('');
        this.searchAreas('');

        

        


        
    }    


    checkAllDDLFinsih() {
        if (this.isFinishStatusDDL && this.isFinishProvinceDDL) {


            if (this.requestStatusDefault != null && this.requestStatusDefault != "0") {
                this.requestStatusSelected = this.requestStatusDefault;
            } else {
                this.requestStatusSelected = "0";
            }


            this.provinceSearch = this.objSearch.Province;

            this.isFinishStatusDDL = false;
            this.isFinishProvinceDDL = false;
        } 
    }



    onActionFailure(e: Error): void {

        this.helper.alert(e.message);
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this request ?', () => {
            this.http.delete(`api/Request/Remove/${id}`, res => {
                this.grid.refresh();
            });
        });
    }

    getColorSquare(p: any) {
        let colorClass = '';

        if (p.Color == "Yellow") {
            colorClass = 'yellow-square';
        }
        else if (p.Color == "Orange") {
            colorClass = 'orange-square';
        }
        else if (p.Color == "Green")
            colorClass = 'blue-square';

        return colorClass;
    }        

    onSearch() {
    }

    onClearSearch() {        
    }

    findRequestTypes(text: string) {
        this.http.get(`api/Util/GetRequestTypeList?userName=${this.auth.LoginUser}&userType=${this.auth.GroupUserCode}&text=${text}`, res => {
            let tempList = [];
            res.Result.forEach(p => tempList.push({ 'Name': p.Name, 'Value': p.Value }));
            this.requestTypeMList = tempList;            
        });
    }

    searchAreas(text: string) {

        this.http.get(`api/Util/SearchAllAreaList?text=${text}`, res => {
 
            let tempList: any[] = [];
            res.Result.forEach(p => tempList.push(p.Name));
            this.areaMList = tempList;
            this.getProvinceDDL(null);
        });
    }

    getProvinceDDL(e) {

        let areaSearch = "";
        if (e != null && e.value.length > 0) {
            areaSearch = Util.array2String1(e.value, ',');
        }
        areaSearch = areaSearch == "" ? "NA" : areaSearch;

       

        this.http.get(`api/Util/SearchProvinceByArea/${areaSearch}`, res => {
 
            this.provinceDDL = res;
            this.provinceDDL.push({ "Provincecode": "","Provincename":"Tất cả"});
            this.isFinishProvinceDDL = true;

            this.checkAllDDLFinsih();

        }, null);
    }

    


    onCopy(id: number) {
        this.helper.confirm('Are you sure you want to copy this request ?', () => {
            this.http.saveSilent(`api/Request/CopyFromRequestId/${id}`, null, res => {                
                this.helper.alert('Copy success');                
                if (res.LongID > 0 && !Util.isFieldEmpty(res.RequestCode)) {                    
                    
                    this.grid.refresh();
                }
            });
        });
    }


    onExportRequest() {

        let paramsExport = new UrlParams();
        paramsExport.addDate('fromDate', this.fromDate);
        paramsExport.addDate('toDate', this.toDate);
        paramsExport.add('requestTypes', Util.array2String1(this.requestTypesSelected, ';'), '');
        paramsExport.add('requestStatus', this.requestStatusSelected, '');
        paramsExport.add('custSearch', this.keywordCustomerSearch, '');
        paramsExport.add('scSearch', this.keywordSCSearch, '');
        paramsExport.add('requestCode', this.requestCodeSearch, '');
        paramsExport.add('userName', this.auth.LoginUser, '');
        paramsExport.add('userType', this.auth.GroupUserCode, '');
        paramsExport.add('area', Util.array2String1(this.areaSelected, ','), '');
        paramsExport.add('province', this.provinceSearch, '');

 
        let APILink: string = "";
        if (this.auth.GroupUserCode == "HS") {
            APILink = `api/HsMatrixV2/ExportRequestHSV2/${paramsExport.toString()}`;

        } else if (this.auth.GroupUserCode == "SC") {
            APILink = `api/BCMatrixV2/ExportRequestBCV2/${paramsExport.toString()}`;

        } else if (this.auth.GroupUserCode == "FFM") {
            let ffmConfirm = "";
            if (this.requestStatusSelected == "0"
                || this.requestStatusSelected == null
                || this.requestStatusSelected == undefined) {
                ffmConfirm = "";
            } else if (this.requestStatusSelected == "9") {
                ffmConfirm = "N";
            } else {
                ffmConfirm = "A";
            }



            paramsExport.add('ffmConfirm', ffmConfirm, '');
            APILink = `api/FFMMatrixV2/ExportRequestFFMV2/${paramsExport.toString()}`;
        }



        this.isProcessingChangeStatus = true;
        this.http.downloadSelections(APILink, null, res => {
            let fileNameExport = 'RequestExport.xlsx';
            importedSaveAs(res, fileNameExport);
            this.isProcessingChangeStatus = false;
        });

    }


    onCheckRequest(request: any) {
        const index: number = this.requestSelecteds.findIndex(x => x == request.ID);
        if (index !== -1) {
            this.requestSelecteds.splice(index, 1);

        } else {
            this.requestSelecteds.push(request.ID);
        }
    }


    onChangeStatusDone() {

        let headers = new HttpHeaders().set('Content-Type', 'application/json')
        let options = { headers: headers };
        let dat = JSON.stringify(this.requestSelecteds);
        this.isProcessingChangeStatus = true;
        this.httpClient.post<any>(this.baseUrl + "api/Request/ChangeStatusDoneManyRequest", dat, options).subscribe(res => {
            if (res.HasError)
            {
                this.helper.alertFailed('Change status failed');
                this.isProcessingChangeStatus = false;  
            }
            else {
                this.requestSelecteds = [];
                this.helper.alert('Change status success');
                this.isProcessingChangeStatus = false;
                this.onSearch();
                
            }
            this.closeDialogConfirm();
        }, error => {
            console.log(error);
            this.helper.alertFailed('Change status failed');
            this.isProcessingChangeStatus = false;
            this.closeDialogConfirm();
        });



    }



    onChangeStatusInprogress() {

        let headers = new HttpHeaders().set('Content-Type', 'application/json')
        let options = { headers: headers };
        let dat = JSON.stringify(this.requestSelecteds);
        this.isProcessingChangeStatus = true;
        this.httpClient.post<any>(this.baseUrl + "api/Request/ChangeStatusInprogressManyRequest", dat, options).subscribe(res => {
            if (res.HasError) {
                this.helper.alertFailed('Change status failed');
                this.isProcessingChangeStatus = false;
            }
            else {
                this.requestSelecteds = [];
                this.helper.alert('Change status success');
                this.isProcessingChangeStatus = false;
                this.onSearch();

            }
            this.closeDialogConfirm();
        }, error => {
            console.log(error);
            this.helper.alertFailed('Change status failed');
            this.isProcessingChangeStatus = false;
            this.closeDialogInproressConfirm();
        });



    }




    initParamSearch() {

    }

    openDialogConfirmDoneRequest() {
        this.dialogHeaderImport = "Xác nhận chuyển Done " + this.requestSelecteds.length+" request";
        this.dialogConfirmDoneRequest.show();
    }


    openDialogConfirmInprogressRequest() {
        this.dialogHeaderImport = "Xác nhận chuyển Inprogress " + this.requestSelecteds.length + " request";
        this.dialogConfirmInprogressRequest.show();
    }


    closeDialogConfirm() {
        this.dialogConfirmDoneRequest.hide();
        this.dialogConfirmInprogressRequest.hide();
    }
    
    closeDialogInproressConfirm() {
        this.dialogConfirmInprogressRequest.hide();
    }


    /*=== Cụm keep filter search ====================*/

    saveSearchCondition() {


        let currentCondition = localStorage.getItem('SearchTerm');


        if (currentCondition != null && currentCondition != undefined)
        {
            
            let objectTerm = JSON.parse(currentCondition);
            let existsRoute = objectTerm.filter(x => x.route == this.routeHere);
            if (existsRoute.length != 0)
            {
                //============ if route exists ==> update object in list
                objectTerm.forEach((item, i) => {
                    if (item.route === this.routeHere) {
                        objectTerm[i].fromDate = this.fromDate;
                        objectTerm[i].toDate = this.fromDate;
                        objectTerm[i].customerKeyword = this.keywordCustomerSearch;
                        objectTerm[i].scKeyword = this.keywordSCSearch;
                        objectTerm[i].requestCode = this.requestCodeSearch;
                        objectTerm[i].requestTypes = Util.array2String1(this.requestTypesSelected, ';');
                        objectTerm[i].areas = Util.array2String1(this.areaSelected, ',');
                    }
                });
            }
            else
            {
                let paramSearch = {
                    "route": this.routeHere,
                    "fromDate": this.fromDate,
                    "toDate": this.toDate,
                    "customerKeyword": this.keywordCustomerSearch,
                    "status": this.requestStatusSelected,
                    "scKeyword": this.keywordSCSearch,
                    "requestCode": this.requestCodeSearch,
                    "requestTypes": Util.array2String1(this.requestTypesSelected, ';'),
                    "areas": Util.array2String1(this.areaSelected, ',')
                };
                objectTerm.push(paramSearch);
            }

           
            localStorage.setItem('SearchTerm', JSON.stringify(objectTerm));
        } else {

            let paramSearch = {
                "route": this.routeHere,
                "fromDate": this.fromDate,
                "toDate": this.toDate,
                "customerKeyword": this.keywordCustomerSearch,
                "status": this.requestStatusSelected,
                "scKeyword": this.keywordSCSearch,
                "requestCode": this.requestCodeSearch,
                "requestTypes": Util.array2String1(this.requestTypesSelected, ';'),
                "areas": Util.array2String1(this.areaSelected, ',')
            };
            this.lstParamSearch.push(paramSearch);
            localStorage.setItem('SearchTerm', JSON.stringify(this.lstParamSearch));
        }

        this.helper.alert('Save search options successfully!');


    }

    reBindSearchCondition() {

        let searchConditions = localStorage.getItem('SearchTerm');
        let objectSearch: any = null;
        if (searchConditions != null && searchConditions != undefined) {
            debugger;
            objectSearch = JSON.parse(searchConditions);
            let existsRoute = objectSearch.filter(x => x.route == this.routeHere);
            if (existsRoute.length > 0) {
                /*rebind search value*/
                this.fromDate = existsRoute[0].fromDate;
                this.toDate = existsRoute[0].toDate;
                this.keywordCustomerSearch = existsRoute[0].customerKeyword;
                this.keywordSCSearch = existsRoute[0].scKeyword;
                this.requestCodeSearch = existsRoute[0].requestCode;
                this.requestStatusSelected = existsRoute[0].status;

                if (existsRoute[0].requestTypes != null && existsRoute[0].requestTypes != "") {
                    this.requestTypesSelected = existsRoute[0].requestTypes.split(";");
                }


                if (existsRoute[0].areas != null && existsRoute[0].areas != "") {
                    this.areaSelected = existsRoute[0].areas.split(";");
                }
            }



        }



        setTimeout(() => {
            this.onSearch();
        }, 1000);



    }








}
